import React, {useEffect, useState} from 'react';
import {Button, Col, notification, Popconfirm, Row, Table} from "antd";
import Spinner from "../../../spinner";
import {consignorService} from "../../../../services";
import ModalListChangesForApprove from "../../../modals/list-changes-for-approve";
import i18n from "../../../../i18n";
import {getTranslatedConstant, requestTypesList} from "../../../../helpers/translate.helpers";

export default function ActionsToApprove() {
  const [loading, setLoading] = useState(false);
  const [needUpdate, setNeedUpdate] = useState(true);
  const [data, setData] = useState([]);
  const [showChangesModal, setShowChangesModal] = useState(null);

  useEffect(() => {
    if (needUpdate) {
      setLoading(true);
      consignorService
        .getActionsToApproveList()
        .then((resp) => {
          setData(resp);
        })
        .catch((err) => {
          notification.error({
            message: i18n.t('components.notification.titles.getApproveList'),
            description: err.message
          });
        })
        .finally(() => {
          setLoading(false);
          setNeedUpdate(false);
        });
    }
  }, [needUpdate]);

  const handleApprove = (id) => {
    setLoading(true);
    consignorService
      .approveAction(id)
      .then(resp => {
        notification.success({
          message: i18n.t('components.notification.titles.approveAction'),
          description: resp.message,
        });
        setNeedUpdate(true);
      })
      .catch(err => {
        notification.error({
          message: i18n.t('components.notification.titles.approveAction'),
          description: err
        });
        setLoading(false);
      });
  };

  const handleDecline = (id) => {
    setLoading(true);
    consignorService
      .declineAction(id)
      .then(resp => {
        notification.success({
          message: i18n.t('components.notification.titles.declineAction'),
          description: resp.message,
        });
        setNeedUpdate(true);
      })
      .catch(err => {
        notification.error({
          message: i18n.t('components.notification.titles.declineAction'),
          description: err
        });
        setLoading(false);
      });
  };

  const requestType = getTranslatedConstant('requestTypesList');

  const columns = [
    {
      title: i18n.t('consignorPage.actionsToApprove.table.user.title'),
      width: '15%',
      render: (record) => {
        return <>
          <p>{record.userCreator.fio}</p>
          <p>{record.userCreator.companyLogin}</p>
        </>
      }
    },
    {
      title: i18n.t('consignorPage.actionsToApprove.table.type.title'),
      width: '10%',
      render: (record) => {
        const type = Object.entries(requestTypesList).filter((item) => {
          return item[1] === record.type;
        });
        if (type.length === 0) {
          return record.type
        } else {
          return requestType[type[0][0]]
        }
      }
    },
    {
      title: i18n.t('consignorPage.actionsToApprove.table.description.title'),
      key: 'description',
      width: '12%',
      render: (record) => {
        if (record.params.length > 0) {
          return <>
            <div>{record.description}</div>
            <Button
              key={record.id}
              htmlType="button"
              type="primary"
              style={{marginTop: 10}}
              className='btn typical-btn typical-btn-blue typical-btn-xs'
              onClick={() => setShowChangesModal(record.id)}
            >{i18n.t('main.buttons.view')}
            </Button>
            <ModalListChangesForApprove countryId={1} params={record.params} isShow={showChangesModal === record.id} setIsShow={setShowChangesModal}/>
          </>
        } else {
          return record.description;
        }
      }
    },
    {
      title: i18n.t('consignorPage.actionsToApprove.table.dateCreated.title'),
      dataIndex: 'dateCreated',
      key: 'dateCreated',
      width: '8%',
    },
    {
      title: '',
      key: 'approve',
      width: '8%',
      render: data => {
        return (
          <React.Fragment>
            <Popconfirm
              title={i18n.t('main.confirm.questions')}
              okText={i18n.t('main.confirm.answer.yes')}
              cancelText={i18n.t('main.confirm.answer.no')}
              onConfirm={() => {
                handleApprove(data.id);
              }}
            >
              <Button
                type="primary"
                htmlType="button"
                size="small"
                className="small-button typical-btn-green"
              >
                {i18n.t('main.buttons.approve')}
              </Button>
            </Popconfirm>
          </React.Fragment>
        );
      },
    },
    {
      title: '',
      key: 'decline',
      width: '8%',
      render: data => {
        return (
          <React.Fragment>
            <Popconfirm
              title={i18n.t('main.confirm.questions')}
              okText={i18n.t('main.confirm.answer.yes')}
              cancelText={i18n.t('main.confirm.answer.no')}
              onConfirm={() => {
                handleDecline(data.id);
              }}
            >
              <Button
                type="primary"
                htmlType="button"
                size="small"
                className="small-button typical-btn-red"
              >
                {i18n.t('main.buttons.decline')}
              </Button>
            </Popconfirm>
          </React.Fragment>
        );
      }
    },
  ];

  return (
    <React.Fragment>
      <h1 className="content-header">{i18n.t('consignorPage.actionsToApprove.title')}</h1>
      <Spinner loading={loading} tip={i18n.t('main.loadText.loading')}>
        <Table
          style={{minWidth: '700px'}}
          columns={columns}
          dataSource={data}
          locale={{emptyText: i18n.t('main.empty')}}
          rowKey="id"
          size="small"
          pagination={{
            pageSize: 50
          }}
        />
      </Spinner>
    </React.Fragment>
  );
};
